import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { AgentContextProvider } from '../features/agent/agent-context';
import { AuthProvider } from '../features/auth/AuthProvider';
import type { AuthSession } from '../features/auth/types';

export function AppProviders(input: {
  children: ReactNode;
  initialSession?: AuthSession | null;
}): ReactNode {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: { queries: { retry: 1, staleTime: 20_000 } },
  }));
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider {...(input.initialSession === undefined ? {} : { initialSession: input.initialSession })}>
        <AgentContextProvider>
          {input.children}
        </AgentContextProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
